import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SEO from "../SEO/SEO";
import "./HomeCleaning.css";
import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import Adelaidebanner from "../Assets/Services/Adelaide-banner-img.png";
import trueicon from "../Assets/HouseCleaning/true-icon.png";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import getaquote from "../Assets/get_a_quote.jpg";
import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";
import FaqPage from "../Services/FaqPage";
import SuburbsSection from "./SuburbsSection";

const faqData = [
  {
    question: "What house cleaning services does Shiny Cleaning offer?",
    answer:
      "We offer one-off, regular, deep, and end-of-lease cleaning. Choose what fits your needs.",
  },
  {
    question: "How often should I schedule house cleaning with Shiny Cleaning",
    answer:
      "The frequency of house cleaning depends on your preferences and property size. We offer flexible scheduling options, including weekly, fortnightly, monthly, or one-time cleanings, to accommodate your needs.",
  },
  {
    question:
      "Can I request specific cleaning tasks to be included in my house cleaning service?",
    answer:
      "Yes, we tailor our service to suit your requests. Just let us know in advance.",
  },
  {
    question: "Do I need to provide cleaning supplies and equipment?",
    answer:
      "No, our team brings everything needed unless you prefer otherwise.",
  },
  {
    question: "Are the cleaners from Shiny Cleaning trained and experienced?",
    answer:
      "Yes, our professional cleaners are trained, experienced, and background-checked.",
  },
  {
    question: "What if I’m not satisfied with the house cleaning service?",
    answer:
      "We offer a satisfaction guarantee. Contact us within 24 hours and we’ll make it right.",
  },
];

const HomeCleaning = ({ categoryId }) => {
  const [activeIndex, setActiveIndex] = useState(1); // second item open by default

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const [services, setServices] = useState([]);

  useEffect(() => {
    api
      .get("housecleaning") // adjust domain if needed
      .then((response) => {
        const formatted = response.data.map((service) => ({
          title: service.title,
          route: `${service.route}`, // if your route should be wrapped
          img: `/storage/${service.image}`, // Laravel storage path
          alt: service.title,
          desc: service.description,
        }));
        setServices(formatted);
      })
      .catch((error) => console.error("Error fetching services:", error));
  }, []);

  const [item, setItem] = useState(null);

  useEffect(() => {
    api
      .get("WhyChooseHouseCleaning") // ✅ Update if hosted
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setItem(res.data[0]); // only first entry (adjust if needed)
          console.log(res.data[0]);
        }
      })
      .catch((err) => console.error("API Error:", err));
  }, []);

  const [faqData, setFaqData] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  useEffect(() => {
    api
      .get(`faqs/category/${categoryId}`)
      .then((res) => {
        setFaqData(res.data.items);
        setCategoryName(res.data.category);
      })
      .catch((err) => console.error("FAQ Fetch Error", err));
  }, [categoryId]);

  // Fetch slider content from API
  const [sliderData, setSliderData] = useState({
    headline: "House Cleaning Services",
    subtext: "",
  });

  useEffect(() => {
    api
      .get("service-slider/house-cleaning")
      .then((res) => {
        if (res.data) {
          setSliderData({
            headline: res.data.headline,
            subtext: res.data.subtext,
          });
        }
      })
      .catch((err) => console.error("Slider Fetch Error", err));
  }, []);

  return (
    <div>
      <SEO />
      <Header />

      <section
        className="hero-section py-24 text-white text-center relative"
        style={{
          background: `url(${Adelaidebanner}) center/cover`,
          position: "relative",
        }}
      >
        <div className="container mx-auto px-4 relative z-10 mt-5">
          <motion.h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 mt-5"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {sliderData.headline || "House Cleaning Services"}
          </motion.h1>

          {sliderData.subtext && (
            <motion.p
              className="text-lg mb-4 px-4"
              style={{ maxWidth: "800px", margin: "0 auto" }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              {sliderData.subtext}
            </motion.p>
          )}

          <motion.p
            className="text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <span>
              Home
              <Link
                to="/adelaide-service"
                className="text-decoration-none text-white"
              >
                / Services
              </Link>
            </span>
          </motion.p>

          <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
            <Link
              to="/free-quote"
              className="btn btn-danger d-inline-flex align-items-center gap-2"
            >
              Get Free Quote <FaArrowRight />
            </Link>
            <Link
              to="tel:0406958557"
              className="btn btn-primary d-inline-flex align-items-center gap-2"
            >
              Call Now <FaPhoneAlt />
            </Link>
          </div>
        </div>

        {/* Optional Overlay */}
        <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
      </section>

      <section className="service-options text-center">
        <div className="container">
          <h2 className="section-title">Our House Cleaning Services</h2>
          <div className="row">
            {services.map((service, index) => (
              <div className="col-sm-6 col-lg-3 mb-4" key={index}>
                <Link to={service.route} className="text-decoration-none">
                  <div className="service-card">
                    <div className="icon-box mb-3">
                      <img
                        src={`${BASE_URL}${service.img}`}
                        alt={service.alt}
                        className="img-fluid"
                      />
                    </div>
                    <h3>{service.title}</h3>
                    <p>{service.desc}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-choose py-5">
        <div className="why-container container d-flex flex-column flex-lg-row align-items-center justify-content-between">
          {/* Left Text Content */}
          <div className="why-text mb-4 mb-lg-0">
            <h2 className="fw-bold mb-4">
              {item?.heading?.split(" ").slice(0, -3).join(" ")}{" "}
              <span>{item?.heading?.split(" ").slice(-3).join(" ")}</span>
            </h2>
            <ul className="list-unstyled">
              {item?.points?.map((point, index) => (
                <li className="mb-3 d-flex align-items-start" key={index}>
                  <img src={trueicon} alt="check" className="me-2 icon" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Image */}
          <div className="why-image text-center">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
              {/* Before Image */}
              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.before_image}`}
                  alt="Before"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">Before</div>
              </div>

              {/* Arrow */}
              <div className="fw-bold display-5 mx-2 d-none d-md-block">→</div>

              {/* After Image */}
              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.after_image}`}
                  alt="After"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">After</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FaqPage categoryId="House cleaning" />

      <SuburbsSection />

      <section className="quote-section pt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="quote-container container text-center">
              <h2 className=" fw-bold mb-3">
                Book a House Cleaning Service Today
              </h2>
              <p className="mb-4 text-muted mt-5">
                Whether it’s a quick once-off clean or long-term care, Shiny
                Cleaning is your trusted local team for all types of house
                cleaning service in Adelaide & Melbourne. We bring professionalism,
                flexibility, and spotless results to every job.
              </p>

              <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
                <Link
                  to="/free-quote"
                  className="btn btn-outline-info d-inline-flex align-items-center gap-2 "
                >
                  Get Free Quote <FaArrowRight />
                </Link>
                <Link
                  to="tel:0406958557"
                  className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                >
                  Call Now <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-6 px-5">
            <img src={getaquote} className="h-75 w-75" />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomeCleaning;
